import React from 'react';
import Slider from '@mui/material/Slider';
import { useTheme } from '@/services/zustand/theme';
import { Container, materialTheme } from './styles';
import { ThemeProvider } from '@mui/material/styles';
import { YearInput } from '@/components/global/Inputs/YearInput';
import { useFilterClassification } from '@/hooks/useClassification';

export const ValidityPeriod: React.FC = () => {
  const theme = useTheme(state => state.theme);

  const {
    endDate,
    startDate,
    sliderMarks,
    sliderValue,
    handleChangeSlider,
    lessSliderLimitDate,
    handleEndDateChange,
    diffSliderCurrentYear,
    handleStartDateChange,
    handleChangeSliderCommited,
  } = useFilterClassification();

  const valueLabelFormater = (value: number) => `${lessSliderLimitDate + value}`;

  return (
    <ThemeProvider theme={materialTheme}>
      <Container>
        <p className='resizeable-accessibility'>Período de vigência</p>
        <div className='range_wrapper'>
          <YearInput
            placeholder='ANO'
            value={startDate}
            onChange={handleStartDateChange}
            />
          <Slider
            value={sliderValue}
            marks={sliderMarks}
            valueLabelDisplay="auto"
            sx={{ margin: '0 1rem' }}
            max={diffSliderCurrentYear}
            onChange={handleChangeSlider}
            valueLabelFormat={valueLabelFormater}
            defaultValue={[0, diffSliderCurrentYear]}
            onChangeCommitted={handleChangeSliderCommited}
            color={theme === 'light' ? "primary" : "secondary"}
          />
          <YearInput
            value={endDate}
            placeholder='ANO'
            onChange={handleEndDateChange}
          />
        </div>
      </Container>
    </ThemeProvider>
  );
};